/*
 * Zoekpopup (snippets/search-sentir.liquid).
 *
 * Wat het doet: de popup openen en sluiten, tijdens het typen suggesties
 * ophalen bij Shopify, de pillen onder "Most searched" als zoekopdracht
 * behandelen, en de plusknop op een kaart in het mandje leggen.
 *
 * Het meldt ook wat er gezocht is aan de eigen relay (zie meetZoek hieronder).
 *
 * Wat het bewust NIET doet: zelf zoeken. Een eigen index in de browser zou de
 * merknamen uit de tags naar elke bezoeker sturen, en juist die houden we uit
 * de pagina. Shopify zoekt op de server, verdraagt tikfouten, en stuurt alleen
 * de kaartjes terug die sections/search-sentir-results.liquid tekent.
 */
(function () {
  if (window.customElements.get('search-sentir')) return;

  var WACHT = 180; // ms stilte voordat we zoeken; korter voelt nerveus
  var LIMIET = 5; // één beste match plus vier rijen
  var VINK = 450; // ms dat het vinkje blijft staan voordat de popup sluit
  var KIJK = 2500; // ms dat een term stil moet staan voordat hij als gezocht telt
  var HINT = 3400; // ms per hint in het zoekveld; rustig, het is geen lichtkrant
  var HINT_ROL = 500; // iets langer dan de transitie op .ss__hint-regel in de css

  class SearchSentir extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-ss-dialog]');
      this.form = this.querySelector('[data-ss-form]');
      this.veld = this.querySelector('[data-ss-veld]');
      this.wis = this.querySelector('[data-ss-wis]');
      this.inhoud = this.querySelector('[data-ss-inhoud]');
      this.uitkomst = this.querySelector('[data-ss-uitkomst]');
      this.niets = this.querySelector('[data-ss-niets]');
      this.alles = this.querySelector('[data-ss-alles]');
      this.rust = this.querySelector('[data-ss-rust]');
      this.status = this.querySelector('[data-ss-status]');
      this.melding = this.querySelector('[data-ss-melding]');
      this.hintVak = this.querySelector('[data-ss-hint]');
      if (!this.dialog || !this.veld) return;

      this.cache = {};
      this.lopend = null;
      this.hints = [];
      try {
        this.hints = JSON.parse(this.dataset.hints || '[]');
      } catch (fout) {
        /* Dan blijft het bij de plaatshouder uit de html. */
      }
      this.timer = null;
      this.verzoek = null;
      this.opener = null;

      this.onOpenKlik = this.onOpenKlik.bind(this);
      this.onViewport = this.onViewport.bind(this);

      /*
       * Op document en niet op de knop zelf: de header heeft twee plekken voor
       * het zoekicoon, en de theme editor tekent de sectie opnieuw zonder dat
       * dit script opnieuw draait.
       */
      document.addEventListener('click', this.onOpenKlik);

      /*
       * Wie midden in het zoeken de pagina verlaat (terug-knop, een link in de
       * header, tabblad dicht) sluit de popup nooit. pagehide is het laatste
       * moment waarop een beacon nog vertrekt.
       */
      this.onWeg = function () {
        this.stuurZoek('niets');
      }.bind(this);
      window.addEventListener('pagehide', this.onWeg);

      this.dialog.addEventListener('click', this.onDialogKlik.bind(this));
      this.dialog.addEventListener('cancel', this.onCancel.bind(this));
      this.dialog.addEventListener('keydown', this.onKeydown.bind(this));
      this.veld.addEventListener('input', this.onInput.bind(this));
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.wis.addEventListener('click', this.onWis.bind(this));

      this.zetStaat('rust');
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOpenKlik);
      window.removeEventListener('pagehide', this.onWeg);
      this.ontgrendel();
    }

    /* ------------------------------------------------------ open en dicht -- */

    onOpenKlik(event) {
      var knop = event.target.closest('[data-ss-open]');
      if (!knop) return;

      // Geen <dialog>: de link gaat dan gewoon naar de zoekpagina.
      if (typeof this.dialog.showModal !== 'function') return;

      event.preventDefault();
      this.open(knop);
    }

    open(opener) {
      if (this.dialog.open) return;
      this.opener = opener || document.activeElement;

      this.dialog.classList.remove('is-closing');
      this.dialog.showModal();
      document.body.classList.add('overflow-hidden');

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this.onViewport);
        this.onViewport();
      }

      /*
       * Focus in dezelfde tik als de klik. iOS opent het toetsenbord alleen als
       * de focus rechtstreeks uit een handeling van de gebruiker komt; na een
       * timeout of animatieframe blijft het dicht.
       */
      this.veld.focus({ preventScroll: true });

      // Eén frame later, anders is er geen beginstand om vanuit te animeren.
      window.requestAnimationFrame(
        function () {
          this.dialog.classList.add('is-open');
        }.bind(this)
      );

      this.startHints();
    }

    /* ------------------------------------------------------- meetZoek -- */

    /*
     * Wat er gezocht is, naar de eigen relay. Shopify telt alleen wie op Enter
     * drukt en op /search belandt -- in twee dagen proefdraaien bleef daar één
     * zoekopdracht van over -- en Searchanise ziet deze popup helemaal niet.
     * Zonder dit weten we dus niet waarop mensen zoeken.
     *
     * Eén regel per zoekopdracht, niet per toetsaanslag. Wie "vanilla" typt
     * vuurt onderweg "vanil" en "vanill" af; die tellen niet mee. Een term telt
     * pas als hij KIJK milliseconden stil stond (dan heeft iemand echt naar de
     * uitkomst gekeken) of als er meteen iets mee gebeurde.
     *
     * Er gaat geen sessienummer mee, geen cookie en geen adres: twee regels zijn
     * niet aan elkaar of aan een persoon te knopen. De sleutel is willekeurig en
     * dient alleen om dubbeltellen te voorkomen als een beacon opnieuw vertrekt.
     */
    noteerZoek(term, aantal) {
      if (!this.dataset.meetUrl) return;

      // Wat er nog openstond is bekeken en verlaten; dat is ook een uitkomst.
      this.stuurZoek('niets');

      var kop = this.uitkomst.querySelector('#ss-kop-beste');
      var tekst = kop ? kop.textContent : '';
      var soort = 'niets';
      if (aantal > 0) soort = tekst.indexOf('Similar') === 0 ? 'gelijkend' : 'match';

      this.lopend = {
        sleutel: Math.random().toString(36).slice(2, 10) + Date.now().toString(36),
        term: term,
        resultaten: aantal,
        soort: soort,
        gezien: false,
        verstuurd: false,
      };

      window.clearTimeout(this.kijkTimer);
      this.kijkTimer = window.setTimeout(
        function () {
          if (this.lopend) this.lopend.gezien = true;
        }.bind(this),
        KIJK
      );
    }

    /*
     * afloop: geklikt | toegevoegd | zoekpagina | niets. Een zoekopdracht waar
     * niets mee gebeurde en die ook niet lang genoeg in beeld stond, sturen we
     * niet: dat was iemand die nog aan het typen was.
     */
    stuurZoek(afloop, gekozen) {
      var lopend = this.lopend;
      if (!lopend || lopend.verstuurd) return;
      if (afloop === 'niets' && !lopend.gezien) {
        this.lopend = null;
        return;
      }

      lopend.verstuurd = true;
      this.lopend = null;
      window.clearTimeout(this.kijkTimer);

      var ua = String(window.navigator.userAgent || '');
      var omgeving = 'browser';
      if (/FBAN|FBAV|FB_IAB/.test(ua)) omgeving = 'facebook-app';
      else if (/Instagram/.test(ua)) omgeving = 'instagram-app';
      else if (/\bLine\/|Snapchat|TikTok|Pinterest/.test(ua)) omgeving = 'andere-app';

      var tekst = JSON.stringify({
        sleutel: lopend.sleutel,
        term: lopend.term,
        resultaten: lopend.resultaten,
        soort: lopend.soort,
        afloop: afloop,
        gekozen: gekozen || null,
        apparaat: window.innerWidth < 750 ? 'mobiel' : 'desktop',
        omgeving: omgeving,
      });

      /*
       * sendBeacon en niet fetch: een klik op een geur navigeert weg, en dat is
       * precies waar fetch sneuvelt en een beacon nog aankomt. text/plain houdt
       * het een simple request, dus zonder preflight.
       */
      try {
        if (window.navigator && navigator.sendBeacon) {
          navigator.sendBeacon(this.dataset.meetUrl, new Blob([tekst], { type: 'text/plain' }));
          return;
        }
        fetch(this.dataset.meetUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: tekst,
          keepalive: true,
        }).catch(function () {});
      } catch (fout) {
        /* Meten mag nooit het zoeken raken. */
      }
    }

    handleVan(href) {
      var m = /\/products\/([a-z0-9-]+)/.exec(String(href || ''));
      return m ? m[1] : null;
    }

    /* ---------------------------------------------------------- hints -- */

    /*
     * De hint in het lege zoekveld wisselt tussen een paar korte regels. Eén
     * lange zin past niet in het veld op een telefoon, en juist de tweede hint --
     * dat je ook een geur kunt intypen die je al kent -- moet opvallen zonder dat
     * het veld daarvoor een merk hoeft te noemen.
     *
     * De regels rollen als een trommel: de nieuwe komt van onderen, de oude gaat
     * naar boven weg. Dat kan niet met ::placeholder (die kan alleen van kleur
     * en dekking veranderen), dus de hint is een eigen laag over het veld en de
     * echte plaatshouder gaat leeg. Hij wisselt alleen zolang het veld leeg is;
     * de css maakt er bij prefers-reduced-motion een gewone overvloeiing van.
     */
    startHints() {
      this.stopHints();
      if (!this.hintVak || !this.hints.length) return;

      this.veld.placeholder = '';
      this.hintNr = 0;
      this.hintVak.textContent = '';
      this.hintVak.appendChild(this.maakHint(this.hints[0]));
      this.pasIn(this.hintVak.lastElementChild);
      this.toonHint();

      if (this.hints.length < 2) return;
      this.hintTimer = window.setInterval(this.rolHint.bind(this), HINT);
    }

    maakHint(tekst, klasse) {
      var regel = document.createElement('span');
      regel.className = 'ss__hint-regel' + (klasse ? ' ' + klasse : '');
      regel.textContent = tekst;
      return regel;
    }

    /*
     * Past een hint niet in het veld (smalle telefoon, of Weglot maakt hem langer:
     * "Try a perfume you know" werd "Probeer eens een parfum dat je kent"), dan
     * gaat de letter een stapje kleiner, tot 13px, in plaats van dat hij midden in
     * een woord wordt afgeknipt. Nog een keer na een korte pauze, want Weglot
     * vertaalt pas nadat de regel er staat.
     */
    pasIn(regel) {
      if (!regel) return;
      var meet = function () {
        regel.style.fontSize = '';
        var maat = 17;
        while (maat > 13 && regel.scrollWidth > regel.clientWidth + 1) {
          maat -= 1;
          regel.style.fontSize = maat + 'px';
        }
      };
      meet();
      window.setTimeout(meet, 350);
      /* Weglot vervangt de tekst op een eigen moment: meet opnieuw zodra dat gebeurt. */
      if (window.MutationObserver) {
        var kijker = new window.MutationObserver(meet);
        kijker.observe(regel, { childList: true, characterData: true, subtree: true });
        window.setTimeout(function () { kijker.disconnect(); }, 4000);
      }
    }

    rolHint() {
      // Onzichtbaar achter getypte tekst: dan ook niet doorrollen.
      if (this.veld.value.length) return;

      this.hintNr = (this.hintNr + 1) % this.hints.length;

      var oud = this.hintVak.lastElementChild;
      var nieuw = this.maakHint(this.hints[this.hintNr], 'is-onder');
      this.hintVak.appendChild(nieuw);
      this.pasIn(nieuw);

      // De beginstand moet een keer getekend zijn, anders valt er niets te animeren.
      void nieuw.offsetWidth;

      nieuw.classList.remove('is-onder');
      if (oud) oud.classList.add('is-boven');

      window.setTimeout(function () {
        if (oud && oud.parentNode) oud.parentNode.removeChild(oud);
      }, HINT_ROL);
    }

    // De hint staat er alleen als het veld leeg is, net als een plaatshouder.
    toonHint() {
      if (this.hintVak) this.hintVak.hidden = this.veld.value.length > 0;
    }

    stopHints() {
      window.clearInterval(this.hintTimer);
    }

    /* Geeft een belofte terug die vervult zodra de popup echt dicht is. */
    sluit() {
      if (!this.dialog.open) return Promise.resolve();
      if (this.sluiten) return this.sluiten;

      this.dialog.classList.add('is-closing');
      this.dialog.classList.remove('is-open');

      /*
       * Niet op transitionend wachten: die komt niet bij prefers-reduced-motion,
       * en dan blijft de popup voor altijd half dicht staan.
       */
      var stil = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.sluiten = new Promise(
        function (klaar) {
          window.setTimeout(
            function () {
              this.dialog.classList.remove('is-closing');
              if (this.dialog.open) this.dialog.close();
              this.stuurZoek('niets');
              this.ontgrendel();
              this.toonMelding('');
              if (this.opener && typeof this.opener.focus === 'function') this.opener.focus();
              this.sluiten = null;
              klaar();
            }.bind(this),
            stil ? 0 : 170
          );
        }.bind(this)
      );
      return this.sluiten;
    }

    ontgrendel() {
      this.stopHints();
      document.body.classList.remove('overflow-hidden');
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', this.onViewport);
      }
    }

    onViewport() {
      this.dialog.style.setProperty('--ss-vh', window.visualViewport.height + 'px');
    }

    onDialogKlik(event) {
      if (event.target.closest('[data-ss-sluit]')) {
        this.sluit();
        return;
      }

      var atc = event.target.closest('[data-ss-atc]');
      if (atc) {
        event.preventDefault();
        this.voegToe(atc);
        return;
      }

      var alles = event.target.closest('[data-ss-alles]');
      if (alles) {
        this.stuurZoek('zoekpagina');
        return;
      }

      var item = event.target.closest('[data-ss-item]');
      if (item) {
        // Geen preventDefault: de link doet gewoon zijn werk, wij tellen mee.
        this.stuurZoek('geklikt', this.handleVan(item.getAttribute('href')));
        return;
      }

      var term = event.target.closest('[data-ss-term]');
      if (term) {
        this.veld.value = term.dataset.ssTerm;
        this.veld.focus({ preventScroll: true });
        this.onInput(null, true);
      }
    }

    // Escape: de browser wil meteen sluiten, wij willen eerst uitfaden.
    onCancel(event) {
      event.preventDefault();
      this.sluit();
    }

    /* ------------------------------------------------------- toevoegen -- */

    /*
     * Toevoegen loopt via SentirCart (assets/cart-drawer.js), net als elke
     * andere toevoegknop in de winkel: die tekent het mandje opnieuw, werkt de
     * teller in de header bij en meldt het aan Klaviyo. Doen we het hier zelf,
     * dan mist een van die drie vroeg of laat.
     *
     * Daarna gaat de popup dicht en het mandje open. Andersom kan niet: de
     * popup ligt in de top layer, een mandje dat eronder opent is onzichtbaar
     * en niet te bedienen. En het mandje is waar de staffelkorting in beeld
     * komt, dus daar wil je iemand na een eerste geur hebben.
     */
    voegToe(knop) {
      if (knop.dataset.staat) return;

      var id = Number(knop.dataset.ssAtc);
      if (!id) return;

      knop.dataset.staat = 'bezig';
      knop.setAttribute('aria-busy', 'true');
      this.toonMelding('');

      var body = { items: [{ id: id, quantity: 1 }] };
      var viaDrawer = window.SentirCart && typeof window.SentirCart.add === 'function';

      var toevoegen = viaDrawer
        ? window.SentirCart.add(body, { openDrawer: false })
        : fetch(this.dataset.cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (data) {
              if (data.status) throw new Error(data.description || data.message || 'Could not add to cart');
              return data;
            });

      toevoegen
        .then(
          function () {
            knop.dataset.staat = 'klaar';
            knop.removeAttribute('aria-busy');
            this.status.textContent = 'Added to your cart';

            var kaart = knop.closest('.ss-beste, .ss-rij, .ss-kaart');
            var link = kaart && kaart.querySelector('.ss__link');
            this.stuurZoek('toegevoegd', link ? this.handleVan(link.getAttribute('href')) : null);

            // Even het vinkje laten zien; zonder lijkt het alsof er niets gebeurde.
            return new Promise(function (verder) {
              window.setTimeout(verder, VINK);
            });
          }.bind(this)
        )
        .then(
          function () {
            return this.sluit();
          }.bind(this)
        )
        .then(
          function () {
            delete knop.dataset.staat;
            if (viaDrawer) {
              window.SentirCart.open(this.opener);
            } else {
              // Geen drawer op deze pagina: dan is de mandpagina de bevestiging.
              window.location.href = this.dataset.cartUrl;
            }
          }.bind(this)
        )
        .catch(
          function (error) {
            delete knop.dataset.staat;
            knop.removeAttribute('aria-busy');
            // Shopify zegt zelf waarom (uitverkocht, maximum bereikt); dat is
            // bruikbaarder dan een eigen algemene zin.
            this.toonMelding((error && error.message) || 'Could not add to cart. Please try again.');
          }.bind(this)
        );
    }

    toonMelding(tekst) {
      if (!this.melding) return;
      this.melding.textContent = tekst;
      this.melding.hidden = !tekst;
    }

    /* ---------------------------------------------------------- toetsen -- */

    /*
     * Pijltjes lopen door alles wat op dat moment aanklikbaar in de lijst
     * staat; omhoog vanaf de eerste brengt je terug in het veld. Gewone links
     * met focus, geen aria-activedescendant: dat werkt in elke schermlezer
     * zonder dat wij een combobox hoeven na te bouwen.
     */
    onKeydown(event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

      var items = Array.prototype.filter.call(
        this.inhoud.querySelectorAll('[data-ss-item], [data-ss-alles]'),
        function (el) {
          return el.offsetParent !== null;
        }
      );
      if (!items.length) return;

      var plek = items.indexOf(document.activeElement);
      if (plek === -1 && document.activeElement !== this.veld) return;

      event.preventDefault();

      if (event.key === 'ArrowDown') {
        items[Math.min(plek + 1, items.length - 1)].focus();
      } else if (plek <= 0) {
        this.veld.focus();
      } else {
        items[plek - 1].focus();
      }
    }

    /* ------------------------------------------------------------ zoeken -- */

    term() {
      return this.veld.value.trim();
    }

    onInput(event, direct) {
      var term = this.term();
      this.wis.hidden = this.veld.value.length === 0;
      this.toonHint();
      window.clearTimeout(this.timer);

      if (!term.length) {
        /*
         * Veld leeggemaakt: met het kruisje, met backspace, of met Escape --
         * een zoekveld wist zichzelf bij de eerste Escape, nog voor de popup
         * sluit. Wie de uitkomst had gezien en hem dan wegveegt, heeft wel
         * degelijk gezocht; dat mag niet ongeteld verdwijnen.
         */
        this.stuurZoek('niets');
        this.breekAf();
        this.zetStaat('rust');
        return;
      }

      // Een pil is een bewuste keuze; daar hoeft geen bedenktijd voor.
      this.timer = window.setTimeout(this.zoek.bind(this, term), direct ? 0 : WACHT);
    }

    onWis() {
      this.veld.value = '';
      this.veld.focus({ preventScroll: true });
      this.onInput();
    }

    onSubmit(event) {
      event.preventDefault();
      var term = this.term();
      if (!term.length) return;
      this.stuurZoek('zoekpagina');
      window.location.href = this.zoekUrl(term);
    }

    zoekUrl(term) {
      return this.dataset.zoekUrl + '?q=' + encodeURIComponent(term) + '&' + encodeURIComponent('options[prefix]') + '=last';
    }

    breekAf() {
      if (this.verzoek) this.verzoek.abort();
      this.verzoek = null;
    }

    zoek(term) {
      var sleutel = term.toLowerCase();

      if (this.cache[sleutel] !== undefined) {
        this.toon(term, this.cache[sleutel]);
        return;
      }

      this.breekAf();
      this.zetStaat('laden');

      var verzoek = 'AbortController' in window ? new AbortController() : null;
      this.verzoek = verzoek;

      var url =
        this.dataset.suggestUrl +
        '?q=' + encodeURIComponent(term) +
        '&' + encodeURIComponent('resources[type]') + '=product' +
        '&' + encodeURIComponent('resources[limit]') + '=' + LIMIET +
        '&' + encodeURIComponent('resources[options][unavailable_products]') + '=last' +
        '&section_id=search-sentir-results';

      fetch(url, verzoek ? { signal: verzoek.signal } : undefined)
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then(
          function (tekst) {
            var blok = new DOMParser().parseFromString(tekst, 'text/html').querySelector('[data-ss-resultaten]');
            var html = blok && Number(blok.dataset.aantal) > 0 ? blok.innerHTML : '';
            this.cache[sleutel] = html;

            // Intussen verder getypt: dit antwoord is van een oudere vraag.
            if (this.term().toLowerCase() !== sleutel) return;
            this.toon(term, html);
          }.bind(this)
        )
        .catch(
          function (error) {
            if (error && error.name === 'AbortError') return;
            /*
             * Zoeken lukt niet (429, netwerk weg). Geen foutmelding in beeld:
             * Enter werkt nog, dus we wijzen alleen de weg naar de zoekpagina.
             */
            if (this.term().toLowerCase() !== sleutel) return;
            this.uitkomst.innerHTML = '';
            this.zetStaat('fout', term);
          }.bind(this)
        );
    }

    toon(term, html) {
      this.uitkomst.innerHTML = html;
      this.inhoud.scrollTop = 0;
      this.zetStaat(html ? 'resultaten' : 'niets', term);

      var aantal = this.uitkomst.querySelectorAll('[data-ss-item]').length;
      this.noteerZoek(term, aantal);
      this.status.textContent = aantal
        ? aantal + (aantal === 1 ? ' result' : ' results') + ' for ' + term
        : 'No results for ' + term;
    }

    /*
     * Eén plek die bepaalt wat er zichtbaar is:
     *   rust        ruststand (pillen + populair)
     *   laden       wat er stond blijft staan, spinner in de balk
     *   resultaten  lijst + knop naar alle resultaten
     *   niets       melding + de ruststand eronder, zodat het niet doodloopt
     *   fout        alleen de knop naar de zoekpagina + de ruststand
     */
    zetStaat(staat, term) {
      this.dataset.staat = staat;
      if (staat === 'laden') return;

      this.uitkomst.hidden = staat !== 'resultaten';
      this.niets.hidden = staat !== 'niets';
      this.alles.hidden = staat !== 'resultaten' && staat !== 'fout';
      this.rust.hidden = staat === 'resultaten';

      if (staat === 'rust') {
        this.uitkomst.innerHTML = '';
        this.status.textContent = '';
        return;
      }

      this.niets.querySelector('[data-ss-niets-term]').textContent = term;
      this.alles.querySelector('[data-ss-alles-term]').textContent = term;
      this.alles.href = this.zoekUrl(term);
    }
  }

  window.customElements.define('search-sentir', SearchSentir);
})();
